import { getHidratationKey } from '@portal-internet/core';
import { useScript } from 'hooks/useScript';
import InnerHTML from 'dangerously-set-html-content';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './text.module.scss';

const safeStringify = (value) => {
    try {
        return JSON.stringify(value, null, 2);
    } catch {
        return '[Invalid JSON]';
    }
};

export default function Text(props) {
    const { text = '', tag = 'div', className = null, estil = null, mida, idDom, dataTestId, isJson = false } = props;
    const { isJavaScriptClientEnabled } = useScript();

    const normalizedText = isJson ? safeStringify(text) : typeof text === 'string' ? text : String(text ?? '');

    const hidratationKey = getHidratationKey(text);

    const stylesText = clsx({
        [styles.text]: true,
        [styles[estil]]: !__isEmpty(estil),
        [styles[mida]]: !__isEmpty(mida),
        [className]: !__isEmpty(className)
    });
    const CustomTag = `${tag}`;

    if (!normalizedText) return <></>;

    if (tag === 'div' && isJavaScriptClientEnabled) {
        return (
            <InnerHTML
                key={hidratationKey}
                className={stylesText}
                html={normalizedText}
                {...(idDom && { id: idDom })}
                data-testid={dataTestId}
            />
        );
    }

    if (isJson) {
        return (
            <CustomTag key={hidratationKey} className={stylesText} {...(idDom && { id: idDom })} data-testid={dataTestId}>
                {normalizedText}
            </CustomTag>
        );
    }

    return (
        <CustomTag
            key={hidratationKey}
            className={stylesText}
            dangerouslySetInnerHTML={{ __html: normalizedText }}
            {...(idDom && { id: idDom })}
            data-testid={dataTestId}
        ></CustomTag>
    );
}
